import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Organisation } from '../../../core/models/organistion.model';

@Component({
  selector: 'idl-organisation-details',
  templateUrl: './organisation-details.component.html',
  styleUrls: ['./organisation-details.component.scss']
})
export class OrganisationDetailsComponent implements OnInit {
  organisation: Organisation;

  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: Organisation) {
    if (dialogData) {
      this.organisation = dialogData;
    }
  }

  ngOnInit() {}
}
